import { Flex, Grid, HStack, Stack } from '@chakra-ui/react';
import { HelivanText } from '../helivan/HelivanText';
import { HelivanColor } from '../helivan/HelivanColor';
import { useNavigate } from 'react-router-dom';
import { HelivanLabel } from '../helivan/HelivanLabel';
import { GoPeople } from 'react-icons/go';
import { useGetSurveyGroupDetailsQuery } from '../../generated/graphql';
import { HelivanLoading } from '../HelivanLoading';

export const SurveyGroups = () => {
  const { data, loading } = useGetSurveyGroupDetailsQuery();
  const surveyGroups = data?.getSurveyGroupsWithDetails ?? [];
  const navigate = useNavigate();

  return (
    <Flex width="full" height="full" flexDirection="column" gap={4} pt={6}>
      {loading ? (
        <HelivanLoading />
      ) : (
        <Grid templateColumns="repeat(3, 1fr)" gap={4} px={10}>
          {surveyGroups.map((group) => (
            <Stack
              width="full"
              key={group.id}
              minWidth="330px"
              py="20px"
              px="30px"
              borderRadius="12px"
              borderColor={HelivanColor.border.primary}
              borderWidth="1px"
              spacing="18px"
              bg="white"
              onClick={() => {
                navigate(`/surveys/group/${group.id}`);
              }}
              _hover={{
                cursor: 'pointer',
                boxShadow: '0px 0px 6px 2px rgba(0, 0, 0, 0.15)',
              }}
              transition="0.2s"
              height="220px"
            >
              <Flex
                height="full"
                justifyContent="space-between"
                flexDirection="column"
              >
                <Stack spacing={2}>
                  <HelivanText variant="sectionHeader">
                    {group.name}
                  </HelivanText>
                  <HStack spacing={2}>
                    <GoPeople size={20} color={HelivanColor.text.blueDark} />
                    <HelivanText variant="largeBody">
                      {group.digitalTwins?.length} personas
                    </HelivanText>
                  </HStack>
                </Stack>
                <Stack spacing={1}>
                  <HelivanText variant="smallBody+">
                    Surveys Conducted
                  </HelivanText>
                  <Stack spacing={2}>
                    <HStack spacing={2}>
                      {group.surveys
                        ?.slice(0, 2)
                        .map((survey, idx) => (
                          <HelivanLabel
                            key={idx}
                            variant={idx % 2 === 0 ? 'blue' : 'green'}
                            label={survey?.title ?? ''}
                          />
                        ))}
                    </HStack>
                    <HStack spacing={2}>
                      {group.surveys
                        ?.slice(2, 4)
                        .map((survey, idx) => (
                          <HelivanLabel
                            key={idx}
                            variant={idx % 2 === 0 ? 'success' : 'error'}
                            label={survey?.title ?? ''}
                          />
                        ))}
                    </HStack>
                  </Stack>
                </Stack>
              </Flex>
            </Stack>
          ))}
        </Grid>
      )}
    </Flex>
  );
};
